module.exports = __webpack_public_path__ + "img/ic_happily.31e9ea5c.png";